<template>
  <b-container>
    <b-row class="header" align-v="center">
      <b-col cols="auto" lg="3" md="3" class="pl-3" v-if="!mobileSearchPressed">
        <b-link class="d-none d-sm-block" @click="redirectHome">
          <b-img src="@/assets/images/logo.svg" />
        </b-link>
        <b-link class="d-sm-none" @click="redirectHome">
          <b-img fluid src="@/assets/images/smallLogo.svg" />
        </b-link>
      </b-col>
      <b-col
        class="d-none d-md-flex align-items-center pr-2 justify-content-end gap-24"
        cols="9"
        lg="9"
        md="9"
        v-if="isAuthenticated && acceptTime"
      >
        <b-form @submit.stop.prevent="goToSearch()">
          <b-input-group v-if="canViewSearch" class="search-input">
            <b-form-input
              name="unusualSearch"
              autocomplete="nope"
              :placeholder="$t('search_by_keyword')"
              data-lpignore="true"
              v-model="searchKeyword"
              type="text"
            ></b-form-input>
            <b-input-group-append>
              <b-button type="submit" variant="outline-primary">
                <Icon name="search" font-scale="1" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>

        <div>
          <span class="mr-2 flex-shrink-0">{{ $t("active_role") }}:</span>
          <b-dropdown
            class="header__dropdown activeRole mr-2"
            left
            variant="outline"
            no-caret
            v-model="selected_role"
          >
            <template #button-content>
              <b class="text-primary font-weight-normal">
                {{ active_role.name }}
              </b>
              <Icon
                name="mdi_chevron-right1"
                class="dropdown-indicator ml-5"
                rotate="-90"
                font-scale="1.3"
              />
            </template>
            <b-dropdown-item-button
              v-for="role in roles"
              :key="role.id"
              :value="role.id"
              :active="role.id === selected_role"
              @click="changeRole(role.id)"
            >
              {{ role.name }}
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
        <Lang dropDown class="d-none d-xl-inline-block" />

        <div
          class="text-right text-nowrap d-none d-xl-inline-block"
          v-if="isAuthenticated && acceptTime"
        >
          <div class="profileDropdown">
            <b-dropdown
              class="header__dropdown activeRole mr-4 profile-button"
              left
              variant="outline"
              no-caret
              v-model="selected_representation"
            >
              <template #button-content>
                <b class="text-primary font-weight-normal">
                  <Icon name="account" variant="outline" font-scale="1.1">
                  </Icon>
                  {{
                    user.personType === "juridical"
                      ? user.companyName
                      : user.first_name + " " + user.last_name
                  }}
                </b>
                <Icon
                  name="mdi_chevron-right1"
                  class="dropdown-indicator ml-1"
                  rotate="-90"
                  font-scale="1.3"
                />
              </template>
              <b-dropdown-header id="dropdown-header-label">
                {{ $t("my_representations") }}
              </b-dropdown-header>
              <b-dropdown-divider></b-dropdown-divider>
              <template v-if="representation.length">
                <b-dropdown-item-button
                  v-for="representation in representation"
                  :key="representation.id"
                  :value="representation.id"
                  :active="representation.id === selected_representation"
                  @click="
                    changeRepresentation(
                      representation.id,
                      representation.role.id
                    )
                  "
                >
                  <span :style="representation.role.length || Object.keys(representation.role).length <= 0 ? 'color:grey;text-decoration: line-through;' : null">
                  {{
                    representation.person_type === "juridical"
                      ? representation.company_name
                      : representation.first_name +
                        " " +
                        representation.last_name
                  }}

                  <template v-if="representation.role.length || Object.keys(representation.role).length <= 0">({{ $t("user_role_is_missing") }})</template>
                  </span>
                </b-dropdown-item-button>
              </template>
              <template v-else>
                <b-dropdown-item-button disabled class="disabled">
                  {{ $t("representations_none") }}
                </b-dropdown-item-button>
              </template>

              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item-button
                class="mt-3"
                button-class="btn-primary"
                @click="redirectToProfile"
              >
                <Icon name="account" variant="outline" font-scale="1.1"> </Icon>
                {{ $t("my_profile") }}
              </b-dropdown-item-button>
              <!--<li>
                <button @click="redirectToProfile" class="btn btn-primary mt-4 w-100">
                  <Icon name="account" variant="outline" font-scale="1.1"> </Icon>
                  {{ $t("my_profile") }}
                </button>
              </li>-->
            </b-dropdown>
          </div>
          <b-button
            size="sm"
            class="mr-2 d-none d-md-inline-flex d-lg-none"
            v-b-toggle.sidebar-sideMenu
          >
            <Icon v-show="sideBarOpen" name="close" />
            <Icon v-show="!sideBarOpen" name="menu" color="primary" />
          </b-button>
          <b-button
            variant="link-outline"
            size="lg"
            class="d-none d-xl-inline-block text-decoration-none header__button"
            @click="logOut"
          >
            <Icon name="logout" variant="outline" font-scale="1.1"> </Icon>
            {{ $t("logout") }}
          </b-button>
        </div>
      </b-col>

      <!--      Mobile header-->
      <b-col
        :class="[
          'text-right d-none d-flex d-sm-flex d-md-none ml-auto',
          { 'col-auto': !mobileSearchPressed },
        ]"
        v-if="isAuthenticated && acceptTime"
      >
        <b-form
          v-if="mobileSearchPressed"
          class="w-100 mr-2"
          @submit.stop.prevent="goToSearch()"
        >
          <b-input-group v-if="canViewSearch" class="search-input">
            <b-form-input
              name="unusualSearch"
              autocomplete="name"
              data-lpignore="true"
              v-model="searchKeyword"
              type="text"
            ></b-form-input>
            <b-input-group-append>
              <b-button type="submit" variant="outline-primary">
                <Icon name="search" font-scale="1" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
        <b-dropdown
          v-if="!mobileSearchPressed"
          class="header__dropdown activeRole mr-2"
          left
          variant="outline"
          no-caret
          v-model="selected_role"
        >
          <template #button-content>
            <b class="text-primary font-weight-normal">
              {{ active_role.name }}
            </b>
            <Icon
              name="mdi_chevron-right1"
              class="dropdown-indicator ml-5"
              rotate="-90"
              font-scale="1.3"
            />
          </template>
          <b-dropdown-item-button
            v-for="role in roles"
            :key="role.id"
            :value="role.id"
            :active="role.id === selected_role"
            @click="changeRole(role.id)"
          >
            {{ role.name }}
          </b-dropdown-item-button>
        </b-dropdown>
        <b-button
          v-if="canViewSearch"
          size="sm"
          class="mr-2 border px-2 py-2"
          variant="secondary"
          @click="mobileSearchPressed = !mobileSearchPressed"
        >
          <Icon
            v-show="!mobileSearchPressed"
            name="search"
            variant="gray-light"
            font-scale="1"
          />
          <Icon
            v-show="mobileSearchPressed"
            name="close"
            variant="primary"
            font-scale="1"
          ></Icon>
        </b-button>
        <b-button
          v-show="!mobileSearchPressed"
          size="sm"
          v-b-toggle.sidebar-sideMenu
        >
          <Icon v-show="sideBarOpen" name="close" />
          <Icon v-show="!sideBarOpen" name="menu" color="primary" />
        </b-button>
      </b-col>
      <b-col class="text-right" v-if="!isAuthenticated">
        <Lang dropDown />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Icon from "@/components/Icon/Icon";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
import { ROUTE_NAMES } from "@/constants/routeConstants";
import Lang from "@/components/Lang";
import { ROLE } from "@/constants/privileges";
import { PERSON_TYPE } from "@/constants/privileges";
import routeMixin from "@/mixins/routeMixin";

export default {
  name: "Kvatro_Header",
  mixins: [routeMixin],
  components: {
    Lang,
    Icon,
  },
  data() {
    return {
      listview: false,
      searchKeyword: "",
      mobileSearchPressed: false,
      selected_representation: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/profile",
      roles: "user/roles",
      active_role: "user/active_role",
      activeCoop: "user/active_cooperative",
      isAuthenticated: "auth/isAuthenticated",
      sideBarOpen: "system/sideBarOpen",
      acceptTime: "user/acceptTime",
      representation: "user/representation",
    }),
    url() {
      return process.env.VUE_APP_OLD_WEBSITE || "#";
    },
    selected_role: {
      get() {
        return this.active_role.id;
      },
    },
    canViewSearch() {
      return this.active_role?.personType === PERSON_TYPE.kvatro;
    },
    console: () => console,
  },
  watch: {
    $route: function () {
      this.listview = this.$route.name === ROUTE_NAMES.meetings;
    },
  },

  methods: {
    async logOut() {
      await this.$http.get("logout");
      await this.$store.dispatch("auth/logout");
      Cookies.remove("CoopApartment");
      await this.$router.push({ name: ROUTE_NAMES.login });
    },
    async changeRole(val) {
      if (val === this.active_role.id) return;
      await this.$store.dispatch("user/changeRole", val);
      // this.$store.commit("user/active_cooperative", {});
      if (val === ROLE.authorized) {
        return this.$router.push({ name: ROUTE_NAMES.meetings, params: {} });
      }
      if (this.$route.name === ROUTE_NAMES.dashboard) {
        return;
      }
      return await this.$router.push({
        name: ROUTE_NAMES.dashboard,
        params: {},
      });
    },
    async changeRepresentation(user_id, role_id) {
      if (role_id === undefined || !role_id) return;
      await this.$store.dispatch("representation/changeRepresentation", {
        user_id: user_id,
        role_id: role_id,
      });

      if (!this.acceptTime) {
        this.$router.push({ name: ROUTE_NAMES.onBoarding });
      } else {
        this.$router.push({ name: ROUTE_NAMES.dashboard });
      }
      //window.location.href="/";
    },
    redirectHome() {
      if (!this.isAuthenticated) {
        if (this.$route.name !== ROUTE_NAMES.landing) {
          this.$router.push({
            name: ROUTE_NAMES.landing,
            params: { id: this.activeCoop.id },
          });
        }
      } else {
        if (this.$route.name !== ROUTE_NAMES.dashboard) {
          this.$router.push({ name: ROUTE_NAMES.dashboard });
        }
      }
    },
    redirectToProfile() {
      if (this.$route.name !== ROUTE_NAMES.profile) {
        this.$router.push({ name: ROUTE_NAMES.profile });
      }
    },
    goToSearch() {
      if (this.searchKeyword === this.$route.query.keyword) return;
      this.searchRoute(this.searchKeyword);
      this.searchKeyword = "";
    },
  },
  async beforeMount() {
    /*
    await this.$store.dispatch("user/profile");

    if( this.user.id ) {

      //console.log(this.user);
      const sessionData = await service.apiv4Session();

      await this.$store.dispatch(
        "representation/representation",
        sessionData.primary_user?.id !== undefined
          ? sessionData.primary_user.id
          : this.user.id
      );
    }
    */
  },
};
</script>
